import { Stack, styled } from "@mui/material"

const StyledFormList = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  gap: theme.spacing(2),
  backgroundColor: theme.palette.common.white,
  alignSelf: "flex-start",
  flex: 1.5,
  width: "100%",
  padding: theme.spacing(2),
  scrollMarginTop: 60,
  borderRadius: (theme.shape.borderRadius as number) * 2,
  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(4),
  },
  [theme.breakpoints.down("sm")]: {
    borderRadius: 0,
    width: "100vw",
    position: "relative",
    left: "50%",
    transform: "translateX(-50%)",
    boxSizing: "border-box",
  },
}))

export default StyledFormList
